import { useMutation, useQueryClient } from "@tanstack/react-query";
import { GcpCertRejectionRequest } from "../../types/gcpCert";
import api from "../../api";

const useRejectGcpCert = (gcpCertID: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (gcpCertRejection: GcpCertRejectionRequest) => {
      return api.gcpCerts.rejectCert(gcpCertRejection)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['gcpCerts'] })
      queryClient.invalidateQueries({ queryKey: ['gcpCerts', gcpCertID] })
    }
  })
}

export default useRejectGcpCert